module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-fluted-hamilton-1.c2f1b100.jpg";